export default {
  monitorsAndAlerts: { id: 'monitors_and_alerts' },
  criterion: { id: 'criterion' },
  indicators: { id: 'indicators' },
  criticality: { id: 'criticality' },
  indicatorName: { id: 'indicator_name' },
  indicatorValue: { id: 'indicator_value' },
  lastReadingTime: { id: 'last_reading_time' },
  allSites: { id: 'all_sites' },
  includeIndicatorsLowerLevel: { id: 'include_indicators_lower_level' },
  policyName: { id: 'policy_name' },
  policyDetails: { id: 'policy_details' },
  sendNotificationsTo: { id: 'send_notifications_to' },
  notificationInfo: { id: 'send_notifications_information' },
  subscribersUpdated: { id: 'subscribers_updated' },
  noSites: { id: 'no_sites' },
}
